
import { Vue } from "vue-class-component";

export default class KgDispute extends Vue {}
